<div class="content h-100 p-4">
  <section>
    <h3>Cadastro Realizado com Sucesso!</h3>
    <p>
      Seu cadastro foi finalizado e estamos analisando os dados fornecidos. Em breve, você receberá um e-mail com mais informações e os próximos passos.
    </p>
  </section>
  <img src="assets/svg/waiting.svg" alt="Imagem de Representando Sucesso" class="w-25">
</div>
